import {NgModule, ModuleWithProviders} from '@angular/core';
import {CommonModule} from '@angular/common';

import {NgbAlert} from './alert';
import {NgbAlertConfig} from './alert-config';

export {NgbAlert} from './alert';
export {NgbAlertConfig} from './alert-config';


export class NgbAlertModule {
  static forRoot(): ModuleWithProviders { return {ngModule: NgbAlertModule, providers: [NgbAlertConfig]}; }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{declarations: [NgbAlert], exports: [NgbAlert], imports: [CommonModule], entryComponents: [NgbAlert]}, ] },
];
/** @nocollapse */
static ctorParameters: ({type: any, decorators?: DecoratorInvocation[]}|null)[] = [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
